export const countriesOptions = [
    {
        id: 'AF',
        en_us: 'Afghanistan',
        pt_br: 'Afeganistão'
    },
    {
        id: 'AX',
        en_us: 'Åland Islands',
        pt_br: 'Ilhas de Aland'
    },
    {
        id: 'AL',
        en_us: 'Albania',
        pt_br: 'Albânia'
    },
    {
        id: 'DZ',
        en_us: 'Algeria',
        pt_br: 'Argélia'
    },
    {
        id: 'AS',
        en_us: 'American Samoa',
        pt_br: 'Samoa Americana'
    },
    {
        id: 'AD',
        en_us: 'Andorra',
        pt_br: 'Andorra'
    },
    {
        id: 'AO',
        en_us: 'Angola',
        pt_br: 'Angola'
    },
    {
        id: 'AI',
        en_us: 'Anguilla',
        pt_br: 'Anguilla'
    },
    {
        id: 'AQ',
        en_us: 'Antarctica',
        pt_br: 'Antártida'
    },
    {
        id: 'AG',
        en_us: 'Antigua and Barbuda',
        pt_br: 'Antiga e Barbuda'
    },
    {
        id: 'AR',
        en_us: 'Argentina',
        pt_br: 'Argentina'
    },
    {
        id: 'AM',
        en_us: 'Armenia',
        pt_br: 'Arménia'
    },
    {
        id: 'AW',
        en_us: 'Aruba',
        pt_br: 'Aruba'
    },
    {
        id: 'AU',
        en_us: 'Australia',
        pt_br: 'Austrália'
    },
    {
        id: 'AT',
        en_us: 'Austria',
        pt_br: 'Áustria'
    },
    {
        id: 'AZ',
        en_us: 'Azerbaijan',
        pt_br: 'Azerbaijão'
    },
    {
        id: 'BS',
        en_us: 'Bahamas',
        pt_br: 'Bahamas'
    },
    {
        id: 'BH',
        en_us: 'Bahrain',
        pt_br: 'Barém'
    },
    {
        id: 'BD',
        en_us: 'Bangladesh',
        pt_br: 'Bangladexe'
    },
    {
        id: 'BB',
        en_us: 'Barbados',
        pt_br: 'Barbados'
    },
    {
        id: 'BY',
        en_us: 'Belarus',
        pt_br: 'Bielorrússia'
    },
    {
        id: 'BE',
        en_us: 'Belgium',
        pt_br: 'Bélgica'
    },
    {
        id: 'BZ',
        en_us: 'Belize',
        pt_br: 'Belize'
    },
    {
        id: 'BJ',
        en_us: 'Benin',
        pt_br: 'Benim'
    },
    {
        id: 'BM',
        en_us: 'Bermuda',
        pt_br: 'Bermudas'
    },
    {
        id: 'BT',
        en_us: 'Bhutan',
        pt_br: 'Butão'
    },
    {
        id: 'BO',
        en_us: 'Bolivia',
        pt_br: 'Bolívia'
    },
    {
        id: 'BA',
        en_us: 'Bosnia and Herzegovina',
        pt_br: 'Bósnia e Herzegovina'
    },
    {
        id: 'BW',
        en_us: 'Botswana',
        pt_br: 'Botsuana'
    },
    {
        id: 'BV',
        en_us: 'Bouvet Island',
        pt_br: 'Ilha Bouvet'
    },
    {
        id: 'BR',
        en_us: 'Brazil',
        pt_br: 'Brasil'
    },
    {
        id: 'IO',
        en_us: 'British Indian Ocean Territory',
        pt_br: 'Território Britânico do Oceano Índico'
    },
    {
        id: 'BN',
        en_us: 'Brunei Darussalam',
        pt_br: 'Brunei'
    },
    {
        id: 'BG',
        en_us: 'Bulgaria',
        pt_br: 'Bulgária'
    },
    {
        id: 'BF',
        en_us: 'Burkina Faso',
        pt_br: 'Burquina Faso'
    },
    {
        id: 'BI',
        en_us: 'Burundi',
        pt_br: 'Burúndi'
    },
    {
        id: 'KH',
        en_us: 'Cambodia',
        pt_br: 'Camboja'
    },
    {
        id: 'CM',
        en_us: 'Cameroon',
        pt_br: 'Camarões'
    },
    {
        id: 'CA',
        en_us: 'Canada',
        pt_br: 'Canadá'
    },
    {
        id: 'CV',
        en_us: 'Cape Verde',
        pt_br: 'Cabo Verde'
    },
    {
        id: 'KY',
        en_us: 'Cayman Islands',
        pt_br: 'Ilhas Cayman'
    },
    {
        id: 'CF',
        en_us: 'Central African Republic',
        pt_br: 'República Centro-Africana'
    },
    {
        id: 'TD',
        en_us: 'Chad',
        pt_br: 'Chade'
    },
    {
        id: 'CL',
        en_us: 'Chile',
        pt_br: 'Chile'
    },
    {
        id: 'CN',
        en_us: 'China',
        pt_br: 'China'
    },
    {
        id: 'CX',
        en_us: 'Christmas Island',
        pt_br: 'Ilha Christmas'
    },
    {
        id: 'CC',
        en_us: 'Cocos (Keeling) Islands',
        pt_br: 'Ilhas Cocos (Keeling)'
    },
    {
        id: 'CO',
        en_us: 'Colombia',
        pt_br: 'Colômbia'
    },
    {
        id: 'KM',
        en_us: 'Comoros',
        pt_br: 'Comores'
    },
    {
        id: 'CG',
        en_us: 'Congo',
        pt_br: 'Congo-Brazzaville'
    },
    {
        id: 'CD',
        en_us: 'Congo, The Democratic Republic of The',
        pt_br: 'República Democrática do Congo'
    },
    {
        id: 'CK',
        en_us: 'Cook Islands',
        pt_br: 'Ilhas Cook'
    },
    {
        id: 'CR',
        en_us: 'Costa Rica',
        pt_br: 'Costa Rica'
    },
    {
        id: 'CI',
        en_us: "Cote D'ivoire",
        pt_br: 'Costa do Marfim'
    },
    {
        id: 'HR',
        en_us: 'Croatia',
        pt_br: 'Croácia'
    },
    {
        id: 'CU',
        en_us: 'Cuba',
        pt_br: 'Cuba'
    },
    {
        id: 'CY',
        en_us: 'Cyprus',
        pt_br: 'Chipre'
    },
    {
        id: 'CZ',
        en_us: 'Czechia',
        pt_br: 'República Checa'
    },
    {
        id: 'DK',
        en_us: 'Denmark',
        pt_br: 'Dinamarca'
    },
    {
        id: 'DJ',
        en_us: 'Djibouti',
        pt_br: 'Jibuti'
    },
    {
        id: 'DM',
        en_us: 'Dominica',
        pt_br: 'Dominica'
    },
    {
        id: 'DO',
        en_us: 'Dominican Republic',
        pt_br: 'República Dominicana'
    },
    {
        id: 'EC',
        en_us: 'Ecuador',
        pt_br: 'Equador'
    },
    {
        id: 'EG',
        en_us: 'Egypt',
        pt_br: 'Egito'
    },
    {
        id: 'SV',
        en_us: 'El Salvador',
        pt_br: 'Salvador'
    },
    {
        id: 'GQ',
        en_us: 'Equatorial Guinea',
        pt_br: 'Guiné Equatorial'
    },
    {
        id: 'ER',
        en_us: 'Eritrea',
        pt_br: 'Eritreia'
    },
    {
        id: 'EE',
        en_us: 'Estonia',
        pt_br: 'Estónia'
    },
    {
        id: 'ET',
        en_us: 'Ethiopia',
        pt_br: 'Etiópia'
    },
    {
        id: 'FK',
        en_us: 'Falkland Islands (Malvinas)',
        pt_br: 'Ilhas Malvinas'
    },
    {
        id: 'FO',
        en_us: 'Faroe Islands',
        pt_br: 'Ilhas Féroe'
    },
    {
        id: 'FJ',
        en_us: 'Fiji',
        pt_br: 'Fiji'
    },
    {
        id: 'FI',
        en_us: 'Finland',
        pt_br: 'Finlândia'
    },
    {
        id: 'FR',
        en_us: 'France',
        pt_br: 'França'
    },
    {
        id: 'GF',
        en_us: 'French Guiana',
        pt_br: 'Guiana Francesa'
    },
    {
        id: 'PF',
        en_us: 'French Polynesia',
        pt_br: 'Polinésia Francesa'
    },
    {
        id: 'TF',
        en_us: 'French Southern Territories',
        pt_br: 'Terras Austrais e Antárticas Francesas'
    },
    {
        id: 'GA',
        en_us: 'Gabon',
        pt_br: 'Gabão'
    },
    {
        id: 'GM',
        en_us: 'Gambia',
        pt_br: 'Gâmbia'
    },
    {
        id: 'GE',
        en_us: 'Georgia',
        pt_br: 'Geórgia'
    },
    {
        id: 'DE',
        en_us: 'Germany',
        pt_br: 'Alemanha'
    },
    {
        id: 'GH',
        en_us: 'Ghana',
        pt_br: 'Gana'
    },
    {
        id: 'GI',
        en_us: 'Gibraltar',
        pt_br: 'Gibraltar'
    },
    {
        id: 'GR',
        en_us: 'Greece',
        pt_br: 'Grécia'
    },
    {
        id: 'GL',
        en_us: 'Greenland',
        pt_br: 'Gronelândia'
    },
    {
        id: 'GD',
        en_us: 'Grenada',
        pt_br: 'Granada'
    },
    {
        id: 'GP',
        en_us: 'Guadeloupe',
        pt_br: 'Guadeloupe'
    },
    {
        id: 'GU',
        en_us: 'Guam',
        pt_br: 'Guam'
    },
    {
        id: 'GT',
        en_us: 'Guatemala',
        pt_br: 'Guatemala'
    },
    {
        id: 'GG',
        en_us: 'Guernsey',
        pt_br: 'Guernsey'
    },
    {
        id: 'GN',
        en_us: 'Guinea',
        pt_br: 'Guiné'
    },
    {
        id: 'GW',
        en_us: 'Guinea-bissau',
        pt_br: 'Guiné-Bissau'
    },
    {
        id: 'GY',
        en_us: 'Guyana',
        pt_br: 'Guiana'
    },
    {
        id: 'HT',
        en_us: 'Haiti',
        pt_br: 'Haiti'
    },
    {
        id: 'HM',
        en_us: 'Heard Island and Mcdonald Islands',
        pt_br: 'Ilha Heard e Ilhas McDonald'
    },
    {
        id: 'VA',
        en_us: 'Holy See (Vatican City State)',
        pt_br: 'Vaticano'
    },
    {
        id: 'HN',
        en_us: 'Honduras',
        pt_br: 'Honduras'
    },
    {
        id: 'HK',
        en_us: 'Hong Kong',
        pt_br: 'Hong Kong'
    },
    {
        id: 'HU',
        en_us: 'Hungary',
        pt_br: 'Hungria'
    },
    {
        id: 'IS',
        en_us: 'Iceland',
        pt_br: 'Islândia'
    },
    {
        id: 'IN',
        en_us: 'India',
        pt_br: 'Índia'
    },
    {
        id: 'ID',
        en_us: 'Indonesia',
        pt_br: 'Indonésia'
    },
    {
        id: 'IR',
        en_us: 'Iran, Islamic Republic of',
        pt_br: 'Irão'
    },
    {
        id: 'IQ',
        en_us: 'Iraq',
        pt_br: 'Iraque'
    },
    {
        id: 'IE',
        en_us: 'Ireland',
        pt_br: 'Irlanda'
    },
    {
        id: 'IM',
        en_us: 'Isle of Man',
        pt_br: 'Ilha de Man'
    },
    {
        id: 'IL',
        en_us: 'Israel',
        pt_br: 'Israel'
    },
    {
        id: 'IT',
        en_us: 'Italy',
        pt_br: 'Itália'
    },
    {
        id: 'JM',
        en_us: 'Jamaica',
        pt_br: 'Jamaica'
    },
    {
        id: 'JP',
        en_us: 'Japan',
        pt_br: 'Japão'
    },
    {
        id: 'JE',
        en_us: 'Jersey',
        pt_br: 'Jersey'
    },
    {
        id: 'JO',
        en_us: 'Jordan',
        pt_br: 'Jordânia'
    },
    {
        id: 'KZ',
        en_us: 'Kazakhstan',
        pt_br: 'Cazaquistão'
    },
    {
        id: 'KE',
        en_us: 'Kenya',
        pt_br: 'Quénia'
    },
    {
        id: 'KI',
        en_us: 'Kiribati',
        pt_br: 'Quiribáti'
    },
    {
        id: 'KP',
        en_us: "Korea, Democratic People's Republic of",
        pt_br: 'Coreia do Norte'
    },
    {
        id: 'KR',
        en_us: 'Korea, Republic of',
        pt_br: 'Coreia do Sul'
    },
    {
        id: 'KW',
        en_us: 'Kuwait',
        pt_br: 'Cuaite'
    },
    {
        id: 'KG',
        en_us: 'Kyrgyzstan',
        pt_br: 'Quirguistão'
    },
    {
        id: 'LA',
        en_us: "Lao People's Democratic Republic",
        pt_br: 'Laus'
    },
    {
        id: 'LV',
        en_us: 'Latvia',
        pt_br: 'Letónia'
    },
    {
        id: 'LB',
        en_us: 'Lebanon',
        pt_br: 'Líbano'
    },
    {
        id: 'LS',
        en_us: 'Lesotho',
        pt_br: 'Lesoto'
    },
    {
        id: 'LR',
        en_us: 'Liberia',
        pt_br: 'Libéria'
    },
    {
        id: 'LY',
        en_us: 'Libyan Arab Jamahiriya',
        pt_br: 'Líbia'
    },
    {
        id: 'LI',
        en_us: 'Liechtenstein',
        pt_br: 'Listenstaine'
    },
    {
        id: 'LT',
        en_us: 'Lithuania',
        pt_br: 'Lituânia'
    },
    {
        id: 'LU',
        en_us: 'Luxembourg',
        pt_br: 'Luxemburgo'
    },
    {
        id: 'MO',
        en_us: 'Macao',
        pt_br: 'Macao'
    },
    {
        id: 'MK',
        en_us: 'Macedonia, The Former Yugoslav Republic of',
        pt_br: 'Macedónia'
    },
    {
        id: 'MG',
        en_us: 'Madagascar',
        pt_br: 'Madagáscar'
    },
    {
        id: 'MW',
        en_us: 'Malawi',
        pt_br: 'Maláui'
    },
    {
        id: 'MY',
        en_us: 'Malaysia',
        pt_br: 'Malásia'
    },
    {
        id: 'MV',
        en_us: 'Maldives',
        pt_br: 'Maldivas'
    },
    {
        id: 'ML',
        en_us: 'Mali',
        pt_br: 'Mali'
    },
    {
        id: 'MT',
        en_us: 'Malta',
        pt_br: 'Malta'
    },
    {
        id: 'MH',
        en_us: 'Marshall Islands',
        pt_br: 'Ilhas Marechal'
    },
    {
        id: 'MQ',
        en_us: 'Martinique',
        pt_br: 'Martinica'
    },
    {
        id: 'MR',
        en_us: 'Mauritania',
        pt_br: 'Mauritânia'
    },
    {
        id: 'MU',
        en_us: 'Mauritius',
        pt_br: 'Maurícia'
    },
    {
        id: 'YT',
        en_us: 'Mayotte',
        pt_br: 'Maiote'
    },
    {
        id: 'MX',
        en_us: 'Mexico',
        pt_br: 'México'
    },
    {
        id: 'FM',
        en_us: 'Micronesia, Federated States of',
        pt_br: 'Micronésia'
    },
    {
        id: 'MD',
        en_us: 'Moldova, Republic of',
        pt_br: 'Moldávia'
    },
    {
        id: 'MC',
        en_us: 'Monaco',
        pt_br: 'Mónaco'
    },
    {
        id: 'MN',
        en_us: 'Mongolia',
        pt_br: 'Mongólia'
    },
    {
        id: 'ME',
        en_us: 'Montenegro',
        pt_br: 'Montenegro'
    },
    {
        id: 'MS',
        en_us: 'Montserrat',
        pt_br: 'Montserrat'
    },
    {
        id: 'MA',
        en_us: 'Morocco',
        pt_br: 'Marrocos'
    },
    {
        id: 'MZ',
        en_us: 'Mozambique',
        pt_br: 'Moçambique'
    },
    {
        id: 'MM',
        en_us: 'Myanmar',
        pt_br: 'Mianmar'
    },
    {
        id: 'NA',
        en_us: 'Namibia',
        pt_br: 'Namíbia'
    },
    {
        id: 'NR',
        en_us: 'Nauru',
        pt_br: 'Nauru'
    },
    {
        id: 'NP',
        en_us: 'Nepal',
        pt_br: 'Nepal'
    },
    {
        id: 'NL',
        en_us: 'Netherlands',
        pt_br: 'Países Baixos'
    },
    {
        id: 'AN',
        en_us: 'Netherlands Antilles',
        pt_br: 'Antilhas Holandesas'
    },
    {
        id: 'NC',
        en_us: 'New Caledonia',
        pt_br: 'Nova Caledónia'
    },
    {
        id: 'NZ',
        en_us: 'New Zealand',
        pt_br: 'Nova Zelândia'
    },
    {
        id: 'NI',
        en_us: 'Nicaragua',
        pt_br: 'Nicarágua'
    },
    {
        id: 'NE',
        en_us: 'Niger',
        pt_br: 'Níger'
    },
    {
        id: 'NG',
        en_us: 'Nigeria',
        pt_br: 'Nigéria'
    },
    {
        id: 'NU',
        en_us: 'Niue',
        pt_br: 'Niue'
    },
    {
        id: 'NF',
        en_us: 'Norfolk Island',
        pt_br: 'Ilha Norfolk'
    },
    {
        id: 'MP',
        en_us: 'Northern Mariana Islands',
        pt_br: 'Ilhas Marianas Setentrionais'
    },
    {
        id: 'NO',
        en_us: 'Norway',
        pt_br: 'Noruega'
    },
    {
        id: 'OM',
        en_us: 'Oman',
        pt_br: 'Omã'
    },
    {
        id: 'PK',
        en_us: 'Pakistan',
        pt_br: 'Paquistão'
    },
    {
        id: 'PW',
        en_us: 'Palau',
        pt_br: 'Palau'
    },
    {
        id: 'PS',
        en_us: 'Palestinian Territory, Occupied',
        pt_br: 'Estado da Palestina'
    },
    {
        id: 'PA',
        en_us: 'Panama',
        pt_br: 'Panamá'
    },
    {
        id: 'PG',
        en_us: 'Papua New Guinea',
        pt_br: 'Papua Nova Guiné'
    },
    {
        id: 'PY',
        en_us: 'Paraguay',
        pt_br: 'Paraguai'
    },
    {
        id: 'PE',
        en_us: 'Peru',
        pt_br: 'Peru'
    },
    {
        id: 'PH',
        en_us: 'Philippines',
        pt_br: 'Filipinas'
    },
    {
        id: 'PN',
        en_us: 'Pitcairn',
        pt_br: 'Ilhas Pitcairn'
    },
    {
        id: 'PL',
        en_us: 'Poland',
        pt_br: 'Polónia'
    },
    {
        id: 'PT',
        en_us: 'Portugal',
        pt_br: 'Portugal'
    },
    {
        id: 'PR',
        en_us: 'Puerto Rico',
        pt_br: 'Porto Rico'
    },
    {
        id: 'QA',
        en_us: 'Qatar',
        pt_br: 'Catar'
    },
    {
        id: 'RE',
        en_us: 'Reunion',
        pt_br: 'Reunião'
    },
    {
        id: 'RO',
        en_us: 'Romania',
        pt_br: 'Roménia'
    },
    {
        id: 'RU',
        en_us: 'Russian Federation',
        pt_br: 'Rússia'
    },
    {
        id: 'RW',
        en_us: 'Rwanda',
        pt_br: 'Ruanda'
    },
    {
        id: 'SH',
        en_us: 'Saint Helena',
        pt_br: 'Santa Helena'
    },
    {
        id: 'KN',
        en_us: 'Saint Kitts and Nevis',
        pt_br: 'São Cristóvão e Neves'
    },
    {
        id: 'LC',
        en_us: 'Saint Lucia',
        pt_br: 'Santa Lúcia'
    },
    {
        id: 'PM',
        en_us: 'Saint Pierre and Miquelon',
        pt_br: 'São Pedro e Miquelão'
    },
    {
        id: 'VC',
        en_us: 'Saint Vincent and The Grenadines',
        pt_br: 'São Vicente e Granadinas'
    },
    {
        id: 'WS',
        en_us: 'Samoa',
        pt_br: 'Samoa'
    },
    {
        id: 'SM',
        en_us: 'San Marino',
        pt_br: 'São Marinho'
    },
    {
        id: 'ST',
        en_us: 'Sao Tome and Principe',
        pt_br: 'São Tomé e Príncipe'
    },
    {
        id: 'SA',
        en_us: 'Saudi Arabia',
        pt_br: 'Arábia Saudita'
    },
    {
        id: 'SN',
        en_us: 'Senegal',
        pt_br: 'Senegal'
    },
    {
        id: 'RS',
        en_us: 'Serbia',
        pt_br: 'Sérvia'
    },
    {
        id: 'SC',
        en_us: 'Seychelles',
        pt_br: 'Seicheles'
    },
    {
        id: 'SL',
        en_us: 'Sierra Leone',
        pt_br: 'Serra Leoa'
    },
    {
        id: 'SG',
        en_us: 'Singapore',
        pt_br: 'Singapura'
    },
    {
        id: 'SK',
        en_us: 'Slovakia',
        pt_br: 'Eslováquia'
    },
    {
        id: 'SI',
        en_us: 'Slovenia',
        pt_br: 'Eslovénia'
    },
    {
        id: 'SB',
        en_us: 'Solomon Islands',
        pt_br: 'Salomão'
    },
    {
        id: 'SO',
        en_us: 'Somalia',
        pt_br: 'Somália'
    },
    {
        id: 'ZA',
        en_us: 'South Africa',
        pt_br: 'África do Sul'
    },
    {
        id: 'GS',
        en_us: 'South Georgia and The South Sandwich Islands',
        pt_br: 'Ilhas Geórgia do Sul e Sandwich do Sul'
    },
    {
        id: 'ES',
        en_us: 'Spain',
        pt_br: 'Espanha'
    },
    {
        id: 'LK',
        en_us: 'Sri Lanka',
        pt_br: 'Sri Lanca'
    },
    {
        id: 'SD',
        en_us: 'Sudan',
        pt_br: 'Sudão'
    },
    {
        id: 'SR',
        en_us: 'Suriname',
        pt_br: 'Suriname'
    },
    {
        id: 'SJ',
        en_us: 'Svalbard and Jan Mayen',
        pt_br: 'Svalbard e Jan Mayen'
    },
    {
        id: 'SZ',
        en_us: 'Swaziland',
        pt_br: 'Suazilândia'
    },
    {
        id: 'SE',
        en_us: 'Sweden',
        pt_br: 'Suécia'
    },
    {
        id: 'CH',
        en_us: 'Switzerland',
        pt_br: 'Suíça'
    },
    {
        id: 'SY',
        en_us: 'Syrian Arab Republic',
        pt_br: 'Síria'
    },
    {
        id: 'TW',
        en_us: 'Taiwan, Province of China',
        pt_br: 'Taiuã'
    },
    {
        id: 'TJ',
        en_us: 'Tajikistan',
        pt_br: 'Tajiquistão'
    },
    {
        id: 'TZ',
        en_us: 'Tanzania, United Republic of',
        pt_br: 'Tanzânia'
    },
    {
        id: 'TH',
        en_us: 'Thailand',
        pt_br: 'Tailândia'
    },
    {
        id: 'TL',
        en_us: 'Timor-leste',
        pt_br: 'Timor-Leste'
    },
    {
        id: 'TG',
        en_us: 'Togo',
        pt_br: 'Togo'
    },
    {
        id: 'TK',
        en_us: 'Tokelau',
        pt_br: 'Toquelau'
    },
    {
        id: 'TO',
        en_us: 'Tonga',
        pt_br: 'Tonga'
    },
    {
        id: 'TT',
        en_us: 'Trinidad and Tobago',
        pt_br: 'Trindade e Tobago'
    },
    {
        id: 'TN',
        en_us: 'Tunisia',
        pt_br: 'Tunísia'
    },
    {
        id: 'TR',
        en_us: 'Turkey',
        pt_br: 'Turquia'
    },
    {
        id: 'TM',
        en_us: 'Turkmenistan',
        pt_br: 'Turcomenistão'
    },
    {
        id: 'TC',
        en_us: 'Turks and Caicos Islands',
        pt_br: 'Ilhas Turcas e Caicos'
    },
    {
        id: 'TV',
        en_us: 'Tuvalu',
        pt_br: 'Tuvalu'
    },
    {
        id: 'UG',
        en_us: 'Uganda',
        pt_br: 'Uganda'
    },
    {
        id: 'UA',
        en_us: 'Ukraine',
        pt_br: 'Ucrânia'
    },
    {
        id: 'AE',
        en_us: 'United Arab Emirates',
        pt_br: 'Emirados Árabes Unidos'
    },
    {
        id: 'GB',
        en_us: 'United Kingdom',
        pt_br: 'Reino Unido'
    },
    {
        id: 'US',
        en_us: 'United States',
        pt_br: 'Estados Unidos'
    },
    {
        id: 'UM',
        en_us: 'United States Minor Outlying Islands',
        pt_br: 'Ilhas Menores Distantes dos Estados Unidos'
    },
    {
        id: 'UY',
        en_us: 'Uruguay',
        pt_br: 'Uruguai'
    },
    {
        id: 'UZ',
        en_us: 'Uzbekistan',
        pt_br: 'Usbequistão'
    },
    {
        id: 'VU',
        en_us: 'Vanuatu',
        pt_br: 'Vanuatu'
    },
    {
        id: 'VE',
        en_us: 'Venezuela',
        pt_br: 'Venezuela'
    },
    {
        id: 'VN',
        en_us: 'Viet Nam',
        pt_br: 'Vietname'
    },
    {
        id: 'VG',
        en_us: 'Virgin Islands, British',
        pt_br: 'Ilhas Virgens Britânicas'
    },
    {
        id: 'VI',
        en_us: 'Virgin Islands, U.S.',
        pt_br: 'Ilhas Virgens Americanas'
    },
    {
        id: 'WF',
        en_us: 'Wallis and Futuna',
        pt_br: 'Wallis e Futuna'
    },
    {
        id: 'EH',
        en_us: 'Western Sahara',
        pt_br: 'Saara Ocidental'
    },
    {
        id: 'YE',
        en_us: 'Yemen',
        pt_br: 'Iémen'
    },
    {
        id: 'ZM',
        en_us: 'Zambia',
        pt_br: 'Zâmbia'
    },
    {
        id: 'ZW',
        en_us: 'Zimbabwe',
        pt_br: 'Zimbábue'
    }
]
